import {BlobProvider, PDFViewer} from '@react-pdf/renderer'
import CorporateInvoice from './CorporateInvoice'
import {invoiceData} from '../core/_model'

const PreviewInvoice = () => {
  return (
    <div>
      <div
        style={{
          height: '100vh',
          width: '900px',
          display: 'flex',
          flexDirection: 'column',
          margin: '10px auto',
        }}
      >
        {/* ===== TOP BAR ===== */}
        {/* <div style={{ padding: 10, background: "#111", color: "#fff" }}>
          <PDFDownloadLink
            document={<CorporateInvoice data={invoiceData} />}
            fileName="invoice.pdf"
          >
            {({ loading }) =>
              loading ? "Preparing PDF..." : "Download Invoice"
            }
          </PDFDownloadLink>
        </div> */}

        {/* ===== LIVE PDF PREVIEW ===== */}
        <div style={{flex: 1}}>
          <div style={{width: '900px', height: '100vh', background: 'white'}}>
            <BlobProvider document={<CorporateInvoice data={invoiceData} />}>
              {({url, loading}) =>
                loading ? (
                  <p className='text-center fw-semibold fs-4 mt-5'>Loading PDF...</p>
                ) : (
                  <iframe
                    src={url!}
                    style={{
                      width: '100%',
                      height: '100%',
                      border: 'none',
                      background: 'white',
                      overflow: 'hidden',
                    }}
                  />
                )
              }
            </BlobProvider>
          </div>

          {/* <PDFViewer
            width='100%'
            height='100%   
            style={{
      width: "100%",
      height: "100%",
      border: "none",
      backgroundColor: "white",
    }}'
            showToolbar={false}
          >
            <CorporateInvoice data={invoiceData} />
          </PDFViewer> */}
        </div>
      </div>
    </div>
  )
}

export default PreviewInvoice
